import { useNavigate } from 'react-router-dom';
import { ProfileForm, type ProfileFormValues } from '../components/profile/ProfileForm';
import { useAuth } from '../hooks/useAuth';
import { updateMyProfile } from '../services/usersApi';

/**
 * First-time profile setup. The Layout guard redirects every teacher
 * here on their first sign-in (when roomNumber is null) and won't let
 * them out until they fill it in.
 */
export function ProfileSetup() {
  const { appUser, setAppUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (values: ProfileFormValues): Promise<void> => {
    const updated = await updateMyProfile({
      displayName: values.displayName,
      roomNumber: values.roomNumber,
      allergies: values.allergies,
    });
    setAppUser(updated);
    navigate('/order', { replace: true });
  };

  // For email-password signups displayName is just the email; clear it so
  // the user types a real one. Google signups already have a real name.
  const initialName =
    appUser !== null && appUser.displayName !== appUser.email ? appUser.displayName : '';

  return (
    <section className="min-h-dvh flex items-center justify-center px-6 py-12">
      <div className="bg-wca-surface rounded-card shadow-card p-8 w-full max-w-md">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-wca-gold mb-4">Welcome</p>
        <h1 className="font-display text-3xl text-wca-black mb-2">Set up your profile</h1>
        <p className="text-wca-gray-mid mb-6 text-sm">
          Just a couple of details so we can get your coffee to the right place.
        </p>
        <ProfileForm
          initial={{
            displayName: initialName,
            roomNumber: appUser?.roomNumber ?? '',
            allergies: appUser?.allergies ?? '',
          }}
          submitLabel="Get started"
          onSubmit={handleSubmit}
        />
      </div>
    </section>
  );
}
